import { createBrowserRouter, useParams } from "react-router-dom";

import { Login } from "pages/Login";
import { PrescriptionList } from "pages/PrescriptionList";
import { PrescriptionDetail } from "pages/PrescriptionDetail";

// Garante que o componente seja desmontado/remontado a cada troca de protocolo,
// evitando que estado local (ex: beneficiários) de um protocolo anterior
// permaneça em tela quando a navegação troca apenas o :objectId.
export function PrescriptionDetailRoute() {
    const { objectId } = useParams();

    return <PrescriptionDetail key={objectId} />;
}

export const router = createBrowserRouter([
    {
        path: "/login",
        element: <Login />,
    },
    {
        path: "/",
        element: <PrescriptionList />,
    },
    {
        path: "/prescription/authorization/:objectId",
        element: <PrescriptionDetailRoute />,
    },
]);
